import { useQuery } from "react-query";

async function fetchWorkosAuthEnabled(): Promise<boolean> {
  const controller = new AbortController();
  let timeout: ReturnType<typeof setTimeout> | undefined;
  const timedOut = new Promise<never>((_, reject) => {
    timeout = setTimeout(() => {
      controller.abort();
      reject(new Error("Auth config request timed out"));
    }, 5000);
  });

  try {
    return await Promise.race([
      timedOut,
      (async () => {
        const response = await fetch(
          `${process.env.NEXT_PUBLIC_API_URL}/api/auth/config`,
          {
            signal: controller.signal,
          },
        );
        if (!response.ok) throw new Error("Auth config request failed");
        const data = await response.json();
        return data.workos_auth_enabled === true;
      })(),
    ]);
  } finally {
    clearTimeout(timeout);
  }
}

export function useWorkosAuthEnabled() {
  const { data, isLoading } = useQuery(
    "workosAuthEnabled",
    fetchWorkosAuthEnabled,
    {
      retry: false,
      retryOnMount: false,
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  );
  return { workosAuthEnabled: data === true, isLoading };
}
